module.exports = __webpack_public_path__ + "static/media/icon-royal.856f53f7.png";